export class ConsulterModel {

    /** 窓口担当者メールアドレス */
    consultantMail: string;
    /** 相談者氏名 */
    consulterName: string;
    /** 社員番号 */
    consulterEmpNumber: string;
    /** 所属 */
    consulterDepartment: string;
    /** 電話番号 */
    consulterPhone: string;
    /** メールアドレス */
    consulterMail: string;
    /** 相談区分 */
    harassmentType: string;
    /** 被害日付 */
    injuryDate: string;
    /** 被害時間帯 */
    injuryTime: string;
    /** 被害場所 */
    scene: string;
    /** 行為者１ */
    offender1: string;
    /** 行為者２ */
    offender2: string;
    /** 行為者３ */
    offender3: string;
    /** 内容 */
    contents: string;
    /** 目撃者、証言者１ */
    eyewitness1: string;
    /** 目撃者、証言者２ */
    eyewitness2: string;
    /** 目撃者、証言者３ */
    eyewitness3: string;
    /** 行為者に事実確認可能 */
    hearingToOffender: boolean;
    /** 目撃者、証言者に事実確認可能 */
    hearingToEyewitness: boolean;
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/model/consulter.model.ts